import React from "react";
import Button from "./Button";

export default function MoreInfoCard({img, title, description, buttonContent, type, link, goToNewPage = true}) {
	return (
		<div className={`more-info ${type}-info-card`}>
			<div className='more-info-icon'>
				<img src={img} alt={title}></img>
			</div>
			<p>{title}</p>
			<p>{description}</p>
			<Button content={buttonContent} type={type === "primary" ? "white" : "default"} size={type === "primary" ? "medium" : "small"} link={link} goToNewPage={goToNewPage} />
		</div>
	);
}
